import qs from 'qs'

import { getRequest, putRequest } from '../../utils'
import type { ReviewEntriesResponse } from './types/reviewEntriesResponse'
import type { ReviewEntryDetail } from './types/reviewEntryDetail'
import type { ValidateReviewEntryPayload } from './types/validateReviewEntryBill'

export interface FetchReviewEntriesProps {
  beginDate: string
  endDate: string
  organizationId: string
  page: string
  pageSize: string
}

export interface FetchReviewEntryDetailProps {
  documentId: string
  organizationId: string
}

export interface ValidateReviewEntryProps {
  documentId: string
  organizationId: string
  payload: ValidateReviewEntryPayload
}

export const buildReviewEntriesEndpoint = ({
  beginDate,
  endDate,
  organizationId,
  page,
  pageSize,
}: FetchReviewEntriesProps): string => {
  const query = qs.stringify({ beginDate, endDate, page, pageSize })

  return `/organizations/${organizationId}/ai-entries?${query}`
}

export const fetchReviewEntries = async (props: FetchReviewEntriesProps): Promise<ReviewEntriesResponse> =>
  getRequest(buildReviewEntriesEndpoint(props))

export const buildReviewEntryDetailEndpoint = ({ documentId, organizationId }: FetchReviewEntryDetailProps): string =>
  `/organizations/${organizationId}/ai-entries/${documentId}`

export const fetchReviewEntryDetail = async (props: FetchReviewEntryDetailProps): Promise<ReviewEntryDetail> =>
  getRequest(buildReviewEntryDetailEndpoint(props))

export const validateReviewEntry = async (props: ValidateReviewEntryProps): Promise<void> => {
  const { documentId, organizationId, payload } = props

  return putRequest(`/organizations/${organizationId}/ai-entries/${documentId}/validation`, payload)
}
